import { useToast } from '@app/core/notifications';
import { useFragmentQuery } from '@app/modules/fragments/hooks/useFragment';
import { useFragmentsStartFragmentMediaRegeneration } from '@mi-front/api-v2';
import { useQueryClient } from '@tanstack/react-query';
import { defineMessage, useIntl } from 'react-intl';
import { useFragment } from '../../hooks/useFragment';

const regenerateStartedMessage = defineMessage({
  id: 'fragments.mediaStatus.regenerateStarted',
  defaultMessage: 'Regeneración de media de fragmento iniciada',
});

const regenerateErrorMessage = defineMessage({
  id: 'fragments.mediaStatus.regenerateError',
  defaultMessage: 'No se pudo regenerar la media',
});

/**
 * Starts fragment media regeneration and refreshes the fragment query on success.
 */
export function useFragmentMediaRegeneration() {
  const { fragment } = useFragment();
  const { $t } = useIntl();
  const { notifyInfo, notifyError } = useToast();
  const queryClient = useQueryClient();

  const mutation = useFragmentsStartFragmentMediaRegeneration({
    mutation: {
      onSuccess: async () => {
        notifyInfo($t(regenerateStartedMessage));
        await queryClient.invalidateQueries({
          queryKey: useFragmentQuery.queryKey(fragment.id),
        });
      },
      onError: () => {
        notifyError($t(regenerateErrorMessage));
      },
    },
  });

  function regenerate() {
    mutation.mutate({ fragmentId: fragment.id });
  }

  return {
    regenerate,
    isPending: mutation.isPending,
  };
}
